import { ExperienceTemplateRendererComponentLibrary } from 'experience-template-renderer-react';

import { UitkComponent } from './uitk-component';

import { CarouselSearchWrapper } from '../carousel-search/carousel-search-wrapper';
import { CustomerNotificationTemplateComponent } from './customer-notication-template-component';
import { DynamicSearchMapWrapper } from '../map/dynamic-search-map-wrapper';
import { Filterbar } from '../filterbar';
import { Footer, Header } from '@gc/global-components';
import { ListViewLayout } from './list-view-layout';
import { MainRegion } from './main-region';
import { MapView } from '../map-view';
import { MesoScripts } from 'components/meso/internals/meso-scripts';
import { MesoSideRail } from 'components/meso/meso-side-rail';
import { MitHeader } from 'components/multi-item/multi-item-header';
import { Playback } from 'components/search/playback/playback';
import { ResultsHeader } from 'components/search/results-header';
import { ResultsWrapper } from './results-wrapper';
import { SearchResultsWrapper } from 'components/search/results/search-results-wrapper';
import { SidebarWrapper } from './sidebar-wrapper';
import { SideRailRegion } from './side-rail-region';
import { SRPLayout } from './srp-layout';
import { ToolbarRegion } from './toolbar-region';

export const componentLibrary: ExperienceTemplateRendererComponentLibrary = new Map()
  .set('SearchResultsWrapper', SearchResultsWrapper)
  .set('ResultsHeader', ResultsHeader)
  .set('Sidebar', SidebarWrapper)
  .set('ToolbarRegion', ToolbarRegion)
  .set('Playback', Playback)
  .set('MainRegion', MainRegion)
  .set('ResultsWrapper', ResultsWrapper)
  .set('MitHeader', MitHeader)
  .set('CustomerNotificationTemplateComponent', CustomerNotificationTemplateComponent)
  .set('SideRailRegion', SideRailRegion)
  .set('MesoSideRail', MesoSideRail)
  .set('UitkComponent', UitkComponent)
  .set('Filterbar', Filterbar)
  .set('MapView', MapView)
  .set('DynamicSearchMapWrapper', DynamicSearchMapWrapper)
  .set('ListViewLayout', ListViewLayout)
  .set('CarouselSearchWrapper', CarouselSearchWrapper)
  .set('GlobalControlsSiteHeader', Header)
  .set('Footer', Footer)
  .set('SRPLayout', SRPLayout)
  .set('MesoScripts', MesoScripts);
